import type { Translations } from "../types";

const id: Translations = {
  "meta.title": "Klik berdasarkan Peta Negara",
  "meta.description":
    "Peta dunia interaktif: klik gratis per negara plus dukungan berbayar melalui Stripe, PayPal, dan Buy Me a Coffee.",

  "app.title": "Klik berdasarkan Peta Negara",

  "map.intro":
    "Klik sebuah negara di peta untuk memberikan suara gratis, atau kirim dukungan finansial - keduanya dihitung dalam papan peringkat gabungan di bawah. Peta ini hanya mencerminkan dukungan di dalam aplikasi ini, bukan kekayaan nasional atau PDB yang sebenarnya.",
  "map.verifying": "Memverifikasi …",
  "map.confirmNotRobot": "Sebelum bisa menambahkan klik gratis, konfirmasi dulu bahwa Anda bukan robot:",
  "map.tryAgain": "Coba lagi",
  "map.registeringClick": "Mendaftarkan klik …",
  "map.selectedCountry": "Negara terpilih: {name}.",
  "map.selectFirstFeedback": "Negara telah dipilih. Untuk menambahkan klik gratis, konfirmasi dulu di bawah bahwa Anda bukan robot.",
  "map.verificationExpired": "Verifikasi kedaluwarsa - konfirmasi lagi bahwa Anda bukan robot.",
  "map.slowDown": "Sedikit lebih lambat - tunggu sebentar sebelum klik berikutnya.",
  "map.clickFailed": "Klik tidak dapat didaftarkan. Silakan coba lagi.",
  "map.clickErrorGeneric": "Terjadi kesalahan saat mendaftarkan klik.",
  "map.leaderboardHeading": "Papan Peringkat Negara",
  "map.emptySelection": "Pilih negara di peta untuk mengklik atau mendukungnya.",
  "map.loadingData": "Memuat data …",

  "worldmap.loadError": "Peta tidak dapat dimuat.",
  "worldmap.resetZoom": "Atur ulang zoom",
  "worldmap.resetButton": "⤾ Atur ulang",
  "worldmap.loadingMap": "Memuat peta …",
  "worldmap.unknownCountry": "Tidak diketahui",
  "worldmap.ariaClicks": "{name}: {clicks} klik",
  "worldmap.tooltipClicks": "{clicks} klik",

  "legend.fewer": "Lebih sedikit klik",
  "legend.more": "Lebih banyak klik",

  "list.empty": "Belum ada klik. Jadilah yang pertama!",
  "list.ariaLabel": "Papan peringkat negara berdasarkan klik",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY belum diatur - lihat README untuk konfigurasi.",
  "human.verificationFailedGeneric": "Verifikasi gagal.",
  "human.networkError":
    "Verifikasi tidak dapat dijangkau (kesalahan jaringan) - periksa VITE_SUPABASE_URL, pastikan verify-human sudah di-deploy, dan ALLOWED_ORIGIN; lihat README/NAVODILA.",
  "human.verificationFailedRetry": "Verifikasi gagal, coba lagi.",

  "provider.stripe": "💳 Kartu (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Negara terpilih",
  "panel.currentlyRanked": "Saat ini peringkat #{rank}",
  "panel.shareCopied": "Disalin ✓",
  "panel.shareShared": "Dibagikan ✓",
  "panel.shareButton": "🔗 Bagikan",

  "panel.tableClicks": "Klik",
  "panel.tableFree": "Gratis",
  "panel.tablePaid": "Berbayar",
  "panel.rowAllTime": "Sepanjang waktu",
  "panel.rowThisYear": "Tahun ini",
  "panel.rowThisWeek": "Minggu ini",
  "panel.rowToday": "Hari ini",

  "panel.totalCombined": "Total gabungan:",
  "panel.totalSupport": "Total dukungan:",

  "panel.paymentMethod": "Metode pembayaran",
  "panel.noPaymentMethod": "Saat ini tidak ada metode pembayaran yang tersedia.",
  "panel.supportAmount": "Jumlah dukungan (EUR)",
  "panel.amountRange": "Jumlah harus antara {min} dan {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Perkiraan klik berbayar:",
  "panel.ratioInfo":
    "Rasio: {a} = {b} klik (mis. {c} = {d} klik). Ini hanya perkiraan sebelum pembayaran - jumlah klik akhir selalu dihitung dan dikonfirmasi oleh server berdasarkan pembayaran yang benar-benar terkonfirmasi.",
  "panel.preparing": "Mempersiapkan …",
  "panel.continueWith": "Lanjutkan dengan {provider}",
  "panel.choosePaymentMethod": "Pilih metode pembayaran",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME belum diatur - lihat README untuk konfigurasi.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID belum diatur - lihat README untuk konfigurasi.",

  "panel.paypalAmountInfo": "Jumlah: {amount} (perkiraan {clicks} klik). Selesaikan pembayaran dengan tombol PayPal di bawah.",
  "panel.back": "← Kembali",

  "panel.bmcWarningTitle": "⚠️ Sebelum melanjutkan ke BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Tempelkan kode di bawah ini ke kolom pesan/catatan saat checkout — itu satu-satunya cara kami tahu negara mana yang Anda dukung. Tanpa kode ini, kami tidak dapat mengaitkan pembayaran dengan negara mana pun.",
  "panel.copy": "Salin",
  "panel.copied": "Disalin ✓",
  "panel.suggestedAmount": "Jumlah yang disarankan:",
  "panel.bmcAmountNote":
    "(perkiraan {clicks} klik). Sayangnya BuyMeCoffee tidak mendukung pembawaan jumlah lewat tautan — masukkan/pilih sendiri di situs mereka. Jumlah klik sebenarnya selalu dihitung dari jumlah yang benar-benar Anda kirim di BuyMeCoffee, bukan dari perkiraan ini.",
  "panel.openBmc": "Buka BuyMeCoffee dan lanjutkan →",
  "panel.waitingProvider": "Menunggu konfirmasi pembayaran dari penyedia pembayaran …",
  "panel.waitingConfirmation": "Menunggu konfirmasi pembayaran …",
  "panel.timedOut":
    "Pemeriksaan melebihi batas waktu. Jika Anda telah menyelesaikan pembayaran, peta akan diperbarui setelah server menerima konfirmasi - ini terkadang bisa memakan waktu sedikit lebih lama.",
  "panel.checkAgain": "Periksa lagi",

  "panel.cancelled": "Pembayaran dibatalkan atau tidak berhasil. Peta tidak berubah.",
  "panel.tryAgain": "Coba lagi",

  "panel.confirmed": "✅ Dukungan terkonfirmasi!",
  "panel.confirmedBody": "{country} menerima {clicks} klik berbayar senilai {amount}.",

  "panel.errorPreparingSupport": "Terjadi kesalahan saat mempersiapkan dukungan Anda.",
  "panel.errorPreparingPayment": "Terjadi kesalahan saat mempersiapkan pembayaran.",
  "panel.errorConfirmingPayment": "Terjadi kesalahan saat mengonfirmasi pembayaran.",
  "panel.errorPayingPaypal": "Terjadi kesalahan saat membayar dengan PayPal.",

  "share.unranked": "{flag}{country} butuh dukunganmu di peta dunia!\nBantu ia naik peringkat 👇",
  "share.rank1": "{flag}{country} saat ini berada di #1!\nBantu kami tetap di puncak 👇",
  "share.rankN": "{flag}{country} saat ini berada di #{rank}!\nBantu kami mencapai #1 👇",

  "language.switcherLabel": "Bahasa",
};

export default id;
